import styled from 'styled-components';

import DiffInsured from 'components/summary/DiffInsured/component';

export default styled(DiffInsured)`
  color: var(--grey700);
`;
